import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import type { SessionUtilisateur } from '../api/types.js';
import { CLE_SESSION } from '../auth/queryClient.js';
import { persistanceHorsLigne } from './index.js';
import { estPersistable } from './persistance.js';

export const DELAI_ECRITURE_MS = 2000;

/**
 * Écrit l'instantané 2 s après le dernier succès d'une requête du périmètre.
 * L'écriture relit la session EN CACHE au moment d'écrire : un module coupé
 * entre-temps efface au lieu d'écrire (`persistance.enregistrer`).
 */
export function useSynchroHorsLigne(slug: string, actif: boolean): void {
  const client = useQueryClient();
  useEffect(() => {
    if (!actif) return undefined;
    let minuterie: ReturnType<typeof setTimeout> | null = null;
    const desabonner = client.getQueryCache().subscribe((evenement) => {
      if (evenement.type !== 'updated' || evenement.action.type !== 'success') return;
      const session = client.getQueryData<SessionUtilisateur>(CLE_SESSION);
      const reglage = session?.galeries.find((galerie) => galerie.slug === slug)?.horsLigne;
      if (!session || !reglage) return;
      if (!estPersistable(evenement.query.queryKey, session.compte.id, slug, reglage.perimetre))
        return;
      if (minuterie) clearTimeout(minuterie);
      minuterie = setTimeout(() => {
        void persistanceHorsLigne()
          .enregistrer(client, slug)
          .catch(() => undefined);
      }, DELAI_ECRITURE_MS);
    });
    return () => {
      desabonner();
      if (minuterie) clearTimeout(minuterie);
    };
  }, [client, slug, actif]);
}
